export const API_FAIL = 'API_FAIL';
export const SAVE_TIMELINE_FAIL = 'SAVE_TIMELINE_FAIL';
